import "./Profile_banner.css"

function Profile_banner({ imgSrc, heading, subHeading }) {
    return (
        <>
            <section className='Profile_banner'>
                <div className="banner_img_holder">
                    <div className="img_holder">
                        <img src={imgSrc} alt="" className='banner_img' />
                    </div>
                    <div className="text_holder">
                        <div className="container">
                            <h6>{heading}</h6>
                            <p>{subHeading}</p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Profile_banner;